import { render } from "./PartnersSlider.vue?vue&type=template&id=036a8c81&scoped=true"
import script from "./PartnersSlider.vue?vue&type=script&lang=js"
export * from "./PartnersSlider.vue?vue&type=script&lang=js"

import "./PartnersSlider.vue?vue&type=style&index=0&id=036a8c81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036a8c81"]])

export default __exports__